import { useMutation, useQueryClient } from '@tanstack/react-query';
import { assignMessage } from '../../../api/cmail.api';
import useNotifications from '../../../_lib/notifications/useNotifications';
import { queries } from '../../../queries';
import { useAPIErrorHandler } from '../../../components/hooks/useAPIErrorHandler';
import { CMAIL_THREAD_QUERY_KEY } from '../CmailInbox/useGetCmailMessage';

interface UpdateAssignmentParams {
  msgId: string;
  email: string;
  firstName?: string;
  lastName?: string;
}

export const useUpdateCmailAssignment = () => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();
  const handleAPIError = useAPIErrorHandler();

  return useMutation({
    mutationFn: async ({
      msgId,
      email,
      firstName,
      lastName,
    }: UpdateAssignmentParams) => {
      return assignMessage({
        params: { msgId },
        data: {
          email,
          firstName,
          lastName,
        },
      });
    },
    onSuccess: async (response, variables) => {
      notifications.success(
        `Email assigned to ${variables.firstName || ''} ${
          variables.lastName || variables.email
        }`.trim()
      );
      const detailKey = queries.cmail.detail(variables.msgId).queryKey;
      // Invalidate and refetch all relevant queries
      await Promise.all([
        queryClient.invalidateQueries(queries.cmail.list._def),
        queryClient.invalidateQueries(detailKey),
        queryClient.invalidateQueries(CMAIL_THREAD_QUERY_KEY),
      ]);
      // Force immediate refetch of detail view and thread view
      await Promise.all([
        queryClient.refetchQueries(detailKey),
        queryClient.refetchQueries(CMAIL_THREAD_QUERY_KEY),
      ]);
    },
    onError: handleAPIError('Failed to update assignment. Please try again.'),
  });
};
